module.exports = __webpack_public_path__ + "img/L2.5eb69c83.svg";